import request from '@/utils/request'

// 查询列表
export function apiGetWmsStockSnapshotDetailList (query) {
  return request({
    url: '/inv/invOnhandQuantities/wmsStockSnapshotDetailList',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiWmsStockSnapshotDetailExport (data) {
  return request({
    url: '/inv/invOnhandQuantities/v2/wmsStockSnapshotDetailExport',
    method: 'post',
    data: data
  })
}

// 查询库存余额快照列表下拉列表快照批次时间列表
export function apiGetSnapshotBatchs () {
  return request({
    url: '/inv/invOnhandQuantities/getWmsStockSnapshotParamSnapshotBatchs',
    method: 'get'
  })
}
